import axios from 'axios';
import qs from 'qs';
import moment from "moment";

export default {
    state: {
        banners: [],
        type: 'Amway.ru'
    },
    mutations: {
        set_banners: (state, payload) => {
            state.banners = payload;
        },
        create_banner: (state, payload) => {
            state.banners.push(payload);
        },
        update_banner: (state, payload) => {
            for (let key = 0; key < state.banners.length; key++) {
                let banner = state.banners[key];
                if (banner.id === payload.id) {
                    state.banners.splice(key, 1);
                    state.banners.push(payload);
                    return true;
                }
            }
        },
        delete_banner: (state, payload) => {
            for (let key = 0; key < state.banners.length; key++) {
                let banner = state.banners[key];
                if (banner.id === payload.id) {
                    state.banners.splice(key, 1);
                    return true;
                }
            }
        }
    },
    actions: {
        get_banners: async (ctx, payload) => {
            const request = {
                platform: payload.platform,
            };
            const self = this;
            await axios(process.env.VUE_APP_BACKEND_HOST + "/api/banner/filter", {
                method: 'post',
                data: qs.stringify(request)
            }).then(
                function(response) {
                    if (response.status === 200 && 
                        response.data.status === "success") 
                    {
                        const banners = response.data.result;
                        ctx.commit('set_banners', banners);
                    }
                }
            );
        },
        create_banner: async(ctx, payload) => {
            const data = new FormData();
            data.append('begin_date', moment(payload.dateSpace[0]).format("YYYY-MM-DD"));
            data.append('end_date', moment(payload.dateSpace[1]).format("YYYY-MM-DD"));
            data.append('link', payload.inputButtonLink);
            data.append('order', payload.inputPosition);
            data.append('tag', payload.tagName);
            data.append('vendor', payload.vendorName);

            if (payload.mode && payload.mode === "double") {
                data.append('mode', payload.mode);
                data.append('image_src', payload.backgroundSrc);
                data.append('image_src_mobile', payload.backgroundSrcMobile);
                if ( payload.images_src && payload.images_src.length ) {
                    data.append(`images`, payload.images_src)
                }
            } else {
                data.append("image", payload.image.raw);
                data.append("image_mobile", payload.imageMobile.raw);
                if ( payload.images && payload.images.length ) {
                    for ( let i = 0, len = payload.images.length; i < len; i ++ ) {
                        data.append(`images`, payload.images[i].raw)
                    }
                }
            }

            if (payload.inputCountView)
                data.append('views', payload.inputCountView);
            else {
                data.append('views', 0);
            }

            data.append('platform', payload.platformId);
            data.append('available', payload.visible);
            const langs = [
                {
                    header: payload.inputTitleFirst,
                    additional_text: payload.inputTextFirst,
                    button_text: payload.inputTxtBtnFirst,
                    language: payload.languages[0].id,
                },
                {
                    header: payload.inputTitleSecond,
                    additional_text: payload.inputTextSecond,
                    button_text: payload.inputTxtBtnSecond,
                    language: payload.languages[1].id,
                },
                {
                    header: payload.inputTitleThird,
                    additional_text: payload.inputTextThird,
                    button_text: payload.inputTxtBtnThird,
                    language: payload.languages[1].id,
                },
            ];
            data.append('language_versions', JSON.stringify(langs));

            await axios(process.env.VUE_APP_BACKEND_HOST + '/api/banner/create', {
              data: data,
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'multipart/form-data'}
            }).then(function(response) {
                if (response.data.status === "success") {
                    ctx.commit("create_banner", response.data.result);
                }
            });
        },
        update_banner: async(ctx, payload) => {
            const data = new FormData();

            if (payload.image)
                data.append("image", payload.image.raw);

            if (payload.imageMobile)
                data.append("image_mobile", payload.imageMobile.raw);

            data.append('begin_date', moment(payload.dateSpace[0]).format("YYYY-MM-DD"));
            data.append('end_date', moment(payload.dateSpace[1]).format("YYYY-MM-DD"));
            data.append('link', payload.inputButtonLink);
            data.append('tag', payload.tagName);
            data.append('vendor', payload.vendorName);
            data.append('views', payload.inputCountView);
            data.append('platform', payload.platform);
            data.append('available', payload.visible);

            if (payload.img_id) {
                data.append('del_images', payload.img_id)
            }
            if ( payload.images && payload.images.length ) {
                for ( let i = 0, len = payload.images.length; i < len; i ++ ) {
                    data.append(`images`, payload.images[i].raw)
                }
            }
            let langs = [
                {
                    id: payload.language_versions[0].id,
                    header: payload.inputTitleFirst,
                    additional_text: payload.inputTextFirst,
                    button_text: payload.inputTxtBtnFirst,
                    language: 1
                },
                {
                    id: payload.language_versions[1].id,
                    header: payload.inputTitleSecond || payload.inputTitleFirst,
                    additional_text: payload.inputTextSecond || payload.inputTextFirst,
                    button_text: payload.inputTxtBtnSecond || payload.inputTxtBtnFirst,
                    language: 2
                }
            ];
            if ( payload.language_versions[2] ) {
                langs.push({
                    id: payload.language_versions[2].id,
                    header: payload.inputTitleThird || payload.inputTitleFirst,
                    additional_text: payload.inputTextThird || payload.inputTextFirst,
                    button_text: payload.inputTxtBtnThird || payload.inputTxtBtnFirst,
                    language: 3
                })
            };

            data.append('language_versions', JSON.stringify(langs));

            await axios(process.env.VUE_APP_BACKEND_HOST + '/api/banner/' + payload.id + '/update', {
              data: data,
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'multipart/form-data'}
            }).then(function(response) {
                if (response.data.status === "success") {
                    ctx.commit("update_banner", response.data.result);
                }
            });

        },
        delete_banner: async(ctx, payload) => {
            await axios(process.env.VUE_APP_BACKEND_HOST + '/api/banner/' + payload.id + '/delete', {
              method: "post",
              withCredentials: true,
            }).then(function(response) {
                if (response.data.status === "success") {
                    ctx.commit("delete_banner", {id: payload.id});
                }
            });

        }
    },

    getters: {
        getBanners(state) {
            const banners = [];
            for (let banner of state.banners) {
                const available = [];
                const availableGroups = [];
                let lang1 = banner.language_versions[0] ? banner.language_versions[0] : '';
                let lang2 = banner.language_versions[1] ? banner.language_versions[1] : '';
                let lang3 = banner.language_versions[2] ? banner.language_versions[2] : '';

                if (parseInt(lang1.language) > parseInt(lang2.language)) {
                    lang1 = banner.language_versions[1];
                    lang2 = banner.language_versions[0];
                }
                
                for (let group of banner.available) {
                    available.push(parseInt(group.id));
                    availableGroups.push(group.name);
                }
                const bannerNew = {
                    "id": banner.id,
                    "name": lang1.header,
                    "inputPosition": parseInt(banner.order),
                    "dateSpace": [
                      banner.begin_date,
                      banner.end_date
                    ],
                    "inputCountView": parseInt(banner.views),
                    "inputButtonLink": banner.link,
                    "tagName": parseInt(banner.tag),
                    "vendorName": parseInt(banner.vendor),
                    "visible": available[0],
                    "visibleGroups": availableGroups[0],
                    "inputTitleFirst": lang1.header,
                    "inputTextFirst": lang1.additional_text,
                    "inputTxtBtnFirst": lang1.button_text,
                    "inputTitleSecond": lang2.header,
                    "inputTextSecond": lang2.additional_text,
                    "inputTxtBtnSecond": lang2.button_text,
                    "inputTitleThird": lang3.header,
                    "inputTextThird": lang3.additional_text,
                    "inputTxtBtnThird": lang3.button_text,
                    "backgroundSrc": process.env.VUE_APP_BACKEND_HOST + banner.image,
                    "backgroundSrcMobile": process.env.VUE_APP_BACKEND_HOST + banner.image_mobile,
                    "language_versions": banner.language_versions,
                    "platform": banner.platform,
                    "createdByName": banner.created_by_name,
                    "images": banner.images,
                };

                banners.push(bannerNew);
            }
            return banners;
        }
    }
}